import { FC } from 'react';

type Props = {
	className?: string;
};

const InfoCircleIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 10.0001C2 5.58176 5.58176 2 10.0001 2C14.4184 2 18.0002 5.58176 18.0002 10.0001C18.0002 14.4184 14.4184 18.0002 10.0001 18.0002C5.58176 18.0002 2 14.4184 2 10.0001ZM9.25589 12.9769C9.25589 12.5658 9.58757 12.2327 9.99673 12.2327H10.0034C10.4126 12.2327 10.7443 12.5658 10.7443 12.9769C10.7443 13.3879 10.4126 13.721 10.0034 13.721H9.99673C9.58757 13.721 9.25589 13.3879 9.25589 12.9769ZM9.25589 10.0001C9.25589 10.4111 9.58906 10.7443 10.0001 10.7443C10.4111 10.7443 10.7443 10.4111 10.7443 10.0001V7.02331C10.7443 6.6123 10.4111 6.27911 10.0001 6.27911C9.58906 6.27911 9.25589 6.6123 9.25589 7.02331V10.0001Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default InfoCircleIconSolid;
